import { CLEAR_SEARCH_RESULTS } from '../../utils/actionTypes';

export const clearSearchResults = () => ({
  type: CLEAR_SEARCH_RESULTS,
});
